import { useEffect, useState } from 'react'

interface WindowSize {
  width: number
  height: number
}

function useWindowSize(): WindowSize {
  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: 0,
    height: 0,
  })

  let timeoutId: number

  const handleResize = () => {
    clearTimeout(timeoutId)

    timeoutId = window.setTimeout(() => {
      setWindowSize({
        width: document.body.clientWidth,
        height: window.innerHeight,
      })
    }, 250)
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    handleResize()

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return windowSize
}

export default useWindowSize
